import { render } from "./InvestorCategory.vue?vue&type=template&id=97b4b124"
import script from "./InvestorCategory.vue?vue&type=script&lang=js"
export * from "./InvestorCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__